import { SubmissionError } from "redux-form";

export default (errors) => {
  if (errors.base) {
    throw new SubmissionError(errors);
  }

  if (errors.card_number) {
    throw new SubmissionError({
      card_number: errors.card_number,
      _error: "invalid credit card",
    });
  } else if (errors.card_code) {
    throw new SubmissionError({
      card_code: errors.card_code,
      _error: "invalid card code",
    });
  } else if (errors.card_expiration) {
    throw new SubmissionError({
      year: errors.card_expiration,
      _err: "invalid year",
    });
  } else if (errors.purchaser_email) {
    throw new SubmissionError({
      purchaser_email: errors.purchaser_email,
      _err: "invalid email",
    });
  } else if (errors.purchaser_first_name) {
    throw new SubmissionError({
      purchaser_first_name: errors.purchaser_first_name,
      _err: "invalid first name",
    });
  } else if (errors.purchaser_last_name) {
    throw new SubmissionError({
      purchaser_last_name: errors.purchaser_last_name,
      _err: "invalid last name",
    });
  } else if (errors.captcha) {
    alert(errors.captcha);
  } else {
    throw new Error(errors);
  }
};
